// IJFF Gallery — photos organized by year of past events
// Add new photos here by simply adding entries; the page will render them automatically.

export const GALLERY_YEARS = [
  {
    year: 2024,
    tagline: {
      en: "Growing community",
      id: "Komunitas yang terus berkembang",
      ja: "広がるコミュニティ",
    },
    // stats: { visitors: "35,000", booths: "80", performers: "50+" },  // optional
    photos: [
      {
        src: "/gallery/2024_crowd.jpg",
        caption: {
          en: "Thousands of visitors gathered in front of the main stage",
          id: "Ribuan pengunjung berkumpul di depan panggung utama",
          ja: "メインステージ前に集まった数千人の観客",
        },
        featured: true,
      },
    ],
  },
  {
    year: 2023,
    tagline: {
      en: "Satu Hati · 心ひとつに · One Heart",
      id: "Satu Hati · 心ひとつに · Satu Hati",
      ja: "サトゥ・ハティ・心ひとつに",
    },
    // stats: { visitors: "40,000", booths: "70", performers: "45+" },
    photos: [
      {
        src: "/gallery/2023_dancers.jpg",
        caption: {
          en: "Traditional Javanese dancers by the waterfront at sunset",
          id: "Penari tradisional Jawa di tepi laut saat matahari terbenam",
          ja: "夕暮れの海辺で舞うジャワ伝統舞踊",
        },
        featured: true,
      },
      {
        src: "/gallery/2023_opening.jpg",
        caption: {
          en: "Opening ceremony · 'Satu Hati' theme, 2023",
          id: "Upacara pembukaan · tema 'Satu Hati', 2023",
          ja: "開会式・2023年テーマ「サトゥ・ハティ」",
        },
      },
      {
        src: "/gallery/2023_stage.jpg",
        caption: {
          en: "The main stage · sponsored by Kyodai Remittance, Mandiri, Toyota & more",
          id: "Panggung utama · disponsori Kyodai Remittance, Mandiri, Toyota, dan lainnya",
          ja: "メインステージ・協賛：Kyodai Remittance、Mandiri、Toyota 他",
        },
      },
    ],
  },
];
